import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router, Event } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DatasetsService } from './datasets/datasets.service';

@Component({
  selector: 'app-els',
  templateUrl: './els.component.html',
  styleUrls: ['./els.component.scss'],
})
export class ElsComponent implements OnInit, OnDestroy {
  onDestroy$ = new Subject();
  url: string;

  public constructor(
    private titleService: Title,
    private router: Router,
    private datasetsService: DatasetsService,
  ) {}

  ngOnInit() {
    this.datasetsService
      .loadDatasets()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((datasets) => this.datasetsService.setDatasets(datasets));

    this.router.events.pipe(takeUntil(this.onDestroy$)).subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.url = event.url.split('/').pop();
        this.setTitle();
        this.toggleOffNav();
        this.toggleBodyOverflowReset();
      }
    });
  }

  /**
   * @returns void
   * remove any style and classes on the body caused by modals - called on NavigationEnd
   */
  toggleBodyOverflowReset(): void {
    let body = document.getElementsByTagName('body')[0];
    body.removeAttribute('style');
    body.removeAttribute('class');
  }

  toggleOffNav(): void {
    let navMenu: HTMLElement = document.getElementById('navigationMenu');
    if (navMenu.classList.contains('show')) {
      let closeButton: HTMLElement = document.querySelector('[data-bs-dismiss="offcanvas"]');
      closeButton.click();
    }
  }

  setTitle(): void {
    if (this.url) {
      let formattedTitle = this.url
        .toLowerCase()
        .replace(/(?:^|[\s-/])\w/g, (match) => {
          return match.toUpperCase();
        })
        .replace(/-/g, ' ');
      this.titleService.setTitle(`${formattedTitle} | Eurogeographics`);
    } else {
      this.titleService.setTitle('Open Maps for Europe | Eurogeographics');
    }
  }

  /**
   * @returns void
   */
  ngOnDestroy(): void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }
}
